import { useMemo } from 'react';
import { share } from 'shared-zustand';
import { create } from 'zustand';
import { subscribeWithSelector, persist } from '../../node_modules/zustand/esm/middleware.js';

const useAppColorSchemeStore = create()(subscribeWithSelector(persist((set) => ({
  colorScheme: "light",
  setColorScheme: (scheme) => {
    set({
      colorScheme: scheme
    });
  },
  toggleColorScheme: (toast = false) => {
    set((state) => {
      const nextColorScheme = state.colorScheme === "light" ? "dark" : state.colorScheme === "dark" ? "system" : "light";
      return {
        colorScheme: nextColorScheme
      };
    });
  }
}), {
  name: "app-color-scheme",
  version: 1
})));
if ("BroadcastChannel" in globalThis) {
  share("colorScheme", useAppColorSchemeStore);
}
const getSystemColorScheme = () => {
  const systemColorScheme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  return systemColorScheme;
};
const useColorScheme = () => {
  const { colorScheme, setColorScheme, toggleColorScheme } = useAppColorSchemeStore();
  return {
    schemeChangeEnabled: true,
    colorScheme,
    parsedColorScheme: useMemo(() => colorScheme === "system" ? getSystemColorScheme() : colorScheme, [
      colorScheme
    ]),
    setColorScheme,
    toggleColorScheme
  };
};

export { useColorScheme };
//# sourceMappingURL=useColorScheme.js.map
